let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("kvjaU")).then(() => parcelRequire('c4Fdw'));